module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_add"
  }, [_c('div', {
    staticClass: "addcode"
  }, [_c('div', {
    staticClass: "search_code"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.select
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "户号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入户号",
      "maxlength": 12
    },
    model: {
      value: (_vm.select.account),
      callback: function($$v) {
        _vm.$set(_vm.select, "account", $$v)
      },
      expression: "select.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入表号",
      "maxlength": 12
    },
    model: {
      value: (_vm.select.searchCode),
      callback: function($$v) {
        _vm.$set(_vm.select, "searchCode", $$v)
      },
      expression: "select.searchCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.select.typess),
      callback: function($$v) {
        _vm.$set(_vm.select, "typess", $$v)
      },
      expression: "select.typess"
    }
  }, _vm._l((_vm.typess), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业主姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入业主姓名",
      "maxlength": 12
    },
    model: {
      value: (_vm.select.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.select, "owner_name", $$v)
      },
      expression: "select.owner_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入地址"
    },
    model: {
      value: (_vm.select.address),
      callback: function($$v) {
        _vm.$set(_vm.select, "address", $$v)
      },
      expression: "select.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业主类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.select.nature),
      callback: function($$v) {
        _vm.$set(_vm.select, "nature", $$v)
      },
      expression: "select.nature"
    }
  }, _vm._l((_vm.natures), function(item) {
    return _c('el-option', {
      key: item.num,
      attrs: {
        "label": item.value,
        "value": item.num
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "190px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.select.searchRemark),
      callback: function($$v) {
        _vm.$set(_vm.select, "searchRemark", $$v)
      },
      expression: "select.searchRemark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.select.searchStatus),
      callback: function($$v) {
        _vm.$set(_vm.select, "searchStatus", $$v)
      },
      expression: "select.searchStatus"
    }
  }, [_vm._v("全部表")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.select.searchStatus),
      callback: function($$v) {
        _vm.$set(_vm.select, "searchStatus", $$v)
      },
      expression: "select.searchStatus"
    }
  }, [_vm._v("已选表")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.select.searchStatus),
      callback: function($$v) {
        _vm.$set(_vm.select, "searchStatus", $$v)
      },
      expression: "select.searchStatus"
    }
  }, [_vm._v("未选表")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "spanOfaddCode",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetting
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "codeData"
  }, [_vm._l((_vm.lists), function(list, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "checkbox",
      class: {
        checkboxtrue: list.status == 1
      },
      on: {
        "click": function($event) {
          return _vm.changebox(list, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sb_msg"
    }, [_vm._v("户号：" + _vm._s(list.account))]), _vm._v(" "), _c('span', {
      staticClass: "sb_msg"
    }, [_vm._v("表号：" + _vm._s(list.code))]), _vm._v(" "), _c('span', {
      staticClass: "sb_msg"
    }, [_vm._v("表类型：" + _vm._s(list.type))]), _vm._v(" "), _c('span', {
      staticClass: "small_msg sb_msg"
    }, [_vm._v("户主姓名：" + _vm._s(list.owner_name))]), _vm._v(" "), _c('span', {
      staticClass: "add_msg sb_msg"
    }, [_vm._v("地址：" + _vm._s(list.address))]), _vm._v(" "), _c('span', {
      staticClass: "nature_msg sb_msg"
    }, [_vm._v("业主类型：" + _vm._s(list.nature))]), _vm._v(" "), _c('span', {
      staticClass: "remark_msg"
    }, [_c('h3', [_vm._v("备注：")]), _c('p', [_vm._v(_vm._s(list.remark))])])])
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "15px 0 20px 0"
    },
    attrs: {
      "page-size": _vm.pageSize,
      "layout": "total,prev, pager, next",
      "total": _vm.listLength
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "custom_allcheck",
    staticStyle: {
      "width": "74px"
    }
  }, [_c('div', {
    staticClass: "checkbox",
    class: {
      checkboxtrue: _vm.checkall == true
    },
    on: {
      "click": function($event) {
        return _vm.allcheck()
      }
    },
    model: {
      value: (_vm.checkall),
      callback: function($$v) {
        _vm.checkall = $$v
      },
      expression: "checkall"
    }
  }), _vm._v("\n\t\t\t\t全选\n\t\t\t")]), _vm._v(" "), (_vm.codegirysumbit) ? _c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary",
      "disabled": true
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.codeSumbit) ? _c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sumbitCode()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "spanOfaddCode",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": _vm.pageback
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-bb9cf59c"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addCode.vue
// module id = 548
// module chunks = 1